module.exports = __webpack_public_path__ + "static/media/13-RotHeatExchanger - No cool - El heat.e83529e6.png";